import { fetchAPI, METHODS, parseBody } from './common';

const coordsQuery = ({ lat, lng } = {}) =>
  new URLSearchParams({ lat: String(lat), lng: String(lng) }).toString();

// Time zone id for the coordinates, or undefined when it can't be resolved.
export async function getTimeZoneId(location) {
  const res = await fetchAPI(
    `/geo/timezone?${coordsQuery(location)}`,
    METHODS.get
  );
  const body = await parseBody(res, true);
  return body?.timeZoneId || undefined;
}

// ISO alpha-2 country code for the coordinates, or null. Works logged out.
export async function getCountryCode(location) {
  const res = await fetchAPI(
    `/geo/country?${coordsQuery(location)}`,
    METHODS.get,
    null,
    { noAuthRefresh: true }
  );
  const body = await parseBody(res);
  return body?.countryCode || null;
}
